import {InjectionToken} from '@angular/core';
import {QueryUpdateStrategy} from './strategies/query-update.strategy';

export const SOFTLINE_WWS_UMSATZSTATISTIK_QUERY_UPDATE_STRATEGY = new InjectionToken<QueryUpdateStrategy<never>[]>('SOFTLINE_WWS_UMSATZSTATISTIK_UPDATE_QUERY_STRATEGY')
